import '@/Plugins/moment';
import '@/Plugins/axios';
import '@/Components';
import '@/Plugins/paper';

import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import SvgVue from 'svg-vue';
import Notifications from 'vue-notification';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueElementLoading from 'vue-element-loading';
import TextareaAutosize from 'vue-textarea-autosize';
import Vue2Filters from 'vue2-filters';
import store from '@/Store';
import App from '@/Views/App';
import i18n from '@/Plugins/i18n';
import router from '@/Views/router';
import NProgress from 'vue-nprogress';
import VueCryptojs from 'vue-cryptojs';

Vue.use(VueCryptojs);
Vue.use(Vuex);
Vue.use(Meta);
Vue.use(SvgVue);
Vue.use(Notifications);
Vue.use(TextareaAutosize);
Vue.config.productionTip = false;
Vue.component('VueElementLoading', VueElementLoading);

if (window.app.recaptcha_enabled) {
  Vue.use(VueReCaptcha, { siteKey: window.app.recaptcha_public });
}
const Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: false,
  },
  number: {
    format: '0',
    thousandsSeparator: ',',
    decimalSeparator: '.',
  },
  bytes: {
    decimalDigits: 2,
  },
  percent: {
    decimalDigits: 2,
    multiplier: 100,
    decimalSeparator: '.',
  },
  currency: {
    symbol: window.app.currency_symbol,
    decimalDigits: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolOnLeft: window.app.currency_symbol_on_left,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false,
  },
  pluralize: {
    includeNumber: false,
  },
  ordinal: {
    includeNumber: false,
  },
};

Vue.use(Vue2Filters, Vue2FiltersConfig);
Vue.use(NProgress);

const nprogress = new NProgress();

new Vue({
  i18n,
  store,
  router,
  nprogress,
  render: (h) => h(App),
  mounted() {
    this.initI18n();
    this.$store.dispatch('app/setUser');
    this.$store.dispatch('app/setSettings', window.app);
  },
  methods: {
    initI18n() {
      this.$i18n.locale = document.documentElement.lang;
      this.loadTranslations();
    },
    loadTranslations() {
      axios.get(route('language.get', this.$i18n.locale)).then((response) => {
        this.$i18n.setLocaleMessage(this.$i18n.locale, response.data);
      });
    },
  },
}).$mount('#app');
